import { useRef, useState } from 'react'

function CopyCodeBlock({ children, ...props }) {
  const [copied, setCopied] = useState(false)
  const preRef = useRef(null)

  const handleCopy = async () => {
    const text = preRef.current?.textContent || ''
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
      } catch {
        // ignore — copy unsupported in this environment
      }
      document.body.removeChild(textarea)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    }
  }

  return (
    <div className="group relative">
      <pre
        ref={preRef}
        {...props}
        className="overflow-x-auto rounded-lg bg-slate-900 p-4 text-sm text-slate-100"
      >
        {children}
      </pre>
      <button
        type="button"
        onClick={handleCopy}
        aria-label="Copy to clipboard"
        className="absolute right-2 top-2 rounded bg-slate-700 px-2 py-1 text-xs font-medium text-slate-200 opacity-0 transition-opacity hover:bg-slate-600 hover:text-white group-hover:opacity-100 focus:opacity-100"
      >
        {copied ? 'Copied!' : 'Copy'}
      </button>
    </div>
  )
}

export const copyCodeComponents = {
  pre: CopyCodeBlock,
}

export default CopyCodeBlock
